/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseApi } from './BaseApi';

export class EmailApi extends BaseApi {
  endPoint: string = '/api/admin/emails';

  public summary() {
    return this._get(`${this.endPoint}/summary`, {});
  }

  public triggerEmail(userId?: string) {
    return this._get(
      `${this.endPoint}/summary/trigger/:userId`,
      {
        userId: userId || '',
      }
    );
  }
}
